import axios from "axios";
import store from "@/store";
import router from "@/router";

// 기본 API URL 설정
export const baseUrl = process.env.VUE_APP_API_URL;

// 동적으로 헤더 설정
export const getHeaders = () => {
  const token = localStorage.getItem("accesstoken");
  return {
    "Content-Type": "application/json;charset=UTF-8",
    Accept: "application/json",
    "X-Content-Type-Options": "nosniff",
    "X-AUTH-TOKEN": token || "", // 토큰이 없으면 빈 값 처리
  };
};

// Axios 인스턴스 생성
export const apiClient = axios.create({
  baseURL: baseUrl,
  withCredentials: true,
  timeout: 900000, // 15분 (900초) - 정산 자료 업로드 등 장기 처리 대응
});

// Axios 요청 인터셉터
apiClient.interceptors.request.use(
  (config) => {
    // FormData를 사용하는 경우 Content-Type을 자동으로 설정하도록 함
    if (config.data instanceof FormData) {
      // FormData인 경우 기본 헤더만 설정하고 Content-Type은 브라우저가 자동 설정하도록 함
      const token = localStorage.getItem("accesstoken");
      config.headers = {
        Accept: "application/json",
        "X-Content-Type-Options": "nosniff",
        "X-AUTH-TOKEN": token || "",
      };
    } else {
      // 일반 요청인 경우 기본 헤더 설정
      config.headers = getHeaders();
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Axios 응답 인터셉터
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // JWT 제거 및 로그아웃 처리
      store.commit("LOGOUT");
      store.commit("RESET");
      alert("세션이 만료되었습니다. 다시 로그인해주세요.");
      router.push({ path: "/" }); // 로그인 페이지로 이동
    }
    return Promise.reject(error);
  }
);
